import { createFileRoute, notFound } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import {
    checkTimelinePrivilege,
    initializeTimeline,
    TimelineContainer,
    timelineUrlParamsSchema,
} from '@mews-commander/modules/src/modules/timeline';
import { MewsTeam, RouteType } from '@mews/enums';

const Component: React.FC = () => (
    <TimelineContainer guideLink={createGuideLink(ArticlePath.Timeline)} searchParams={Route.useSearch()} />
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Reservation/Dashboard')({
    validateSearch: timelineUrlParamsSchema,
    beforeLoad: ({ context: { getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState } }) => {
        if (!checkTimelinePrivilege(getState())) {
            throw notFound();
        }
    },
    component: Component,
    loader: ({ context: { dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch }, params, cause }) => {
        if (cause === 'enter') {
            dispatch(initializeTimeline(params.currentEnterpriseId));
        }
    },
    staticData: {
        routeName: RouteName.ReservationDashboard,
        owner: MewsTeam.Reservations,
        type: RouteType.Frontend,
        title: TextKey.TimeLine,
    },
});
